import Cookies from 'js-cookie';
import { BRANDS, LOCALHOST_BOOKING_ENGINE_ENV } from 'config';

const getDefaultAttributes = env => {
  const { hostname } = window.location;
  let domain;

  switch (env) {
    case 'test':
    case 'otrl-stage':
      domain = hostname.replace(/^(widgets\.)/, '.');
      break;
    
    case 'brochure-stage':
      domain = hostname.replace(/^(www\.staging\.)/, '.');
      break;

    case 'brochure-stage-new':
      domain = hostname.replace(/^(staging\.)/, '.');
      break;
    
    case 'prod':
      domain = hostname.replace(/^(www\.)/, '.');
      break;
    
    case 'local':
    default:
      domain = hostname;
  }

  return {
    domain,
    secure: true
  };
};

const getCookieNamespace = (brand, env) =>
  env === 'local'
    ? `${BRANDS[brand]}.${LOCALHOST_BOOKING_ENGINE_ENV}-`
    : '';

export const getCookie = (brand, env, name) => {
  const cookieName = getCookieNamespace(brand, env) + name;
  return Cookies.get(cookieName);
};

export const setCookie = (brand, env, name, value, options = {}) => {
  const cookieName = getCookieNamespace(brand, env) + name;
  const defaultAttributes = getDefaultAttributes(env);
  const attributes = {
    ...defaultAttributes,
    ...options
  };
  return Cookies.set(cookieName, value, attributes);
};

export const deleteCookie = (brand, env, name, options = {}) => {
  const cookieName = getCookieNamespace(brand, env) + name;
  const defaultAttributes = getDefaultAttributes(env);
  const attributes = {
    ...defaultAttributes,
    ...options
  };
  return Cookies.remove(cookieName, attributes);
};
